import colors from "assets/theme/base/colors";

const { text } = colors;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  styleOverrides: {
    root: {
      color: text.main,
    },
  },
};
